import dayjs from "dayjs";
import { IFilter } from "../screens/taskTypes/store/types";

export function isNotDefaultDate<T extends IFilter>(
  obj: T[],
  defaultDates: T[],
) {
  for (let i = 0; i < defaultDates.length; i++) {
    const defaultDate: T = defaultDates[i];
    const objDate = obj.find((item) => item.type === defaultDate.type);

    if (
      !objDate ||
      !dayjs(defaultDate.value as string).isSame(objDate.value as string)
    ) {
      return true;
    }
  }
  return false;
}
